module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_bzgx@2x.dcb688ae.png";